/**
 * The Expo PWA (expo.<domain>, /expo, /pwa/expo): the dining Expo screen
 * (apps/dining/screens/ExpoScreen - every station's tickets per order, Served /
 * Picked up) under the restaurant-account sign-in (apps/kds/KitchenPwa). The old
 * order-level expo board (/api/expo, ExpoContext / ExpoMainPage) is retired.
 * docs/DINING_API_2026-10-28.md §11 / §14 / §15.
 */
import React from 'react';
import { Package } from 'lucide-react';
import ExpoScreen from '@/apps/dining/screens/ExpoScreen';
import KitchenPwa from '@/apps/kds/KitchenPwa';

export default function ExpoApp() {
  return <KitchenPwa app="expo" appName="Expo" icon={Package} accent="#22c55e" Screen={ExpoScreen} what="expo" />;
}
